import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Table, Empty } from "antd";
import CurrencyFormat from "react-currency-format";
import { useMediaQuery } from "react-responsive";
import Widget from "components/Widget/index";
import RequestHandler from "../../../../util/RequestHandler";
import { useHistory } from "react-router-dom";

const AllBankListTable = (props) => {
  const { t } = useTranslation();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  const [currencyList, setCurrencyList] = useState([]);
  const [bankListForTotal, setBankListForTotal] = useState([]);
  const [take, setTake] = useState(10);
  const [skip, setSkip] = useState(0);
  const [count, setCount] = useState(0);
  const [query, setQuery] = useState("");
  const [bankSelect, setBankSelect] = useState([]);

  const history = useHistory();

  useEffect(() => {
    RequestHandler.get(
      `/TenantAccount/GetListForTotal?forUseHomePage=${
        props.forUseHomePage ?? true
      }`
    ).then((response) => {
      var tenantTotalList = [];
      var total = 0;

      response.map((item) => {
        var model = {};
        model.bankLogo = item.bankLogo;
        model.totalBalance = item.balance;
        model.bankName = item.bankName;
        var currencyList = [0, 1, 2];
        if (item.isSetBalancesZero === true) {
          model.try = 0;
          model.usd = 0;
          model.eur = 0;
          tenantTotalList.push(model);
          total += item.balance;
        } else {
          currencyList.map((i) => {
            if (item.tenantList[i]?.currencyId == 1) {
              model.try =
                item.tenantList[i]?.balance === undefined
                  ? 0
                  : item.tenantList[i].balance;
            } else if (item.tenantList[i]?.currencyId == 2) {
              model.usd =
                item.tenantList[i]?.balance === undefined
                  ? 0
                  : item.tenantList[i].balance;
            } else if (item.tenantList[i]?.currencyId == 3) {
              model.eur =
                item.tenantList[i]?.balance === undefined
                  ? 0
                  : item.tenantList[i].balance;
            }
          });
          model.usd === undefined ? (model.usd = 0) : (model.usd = model.usd);
          model.try === undefined ? (model.try = 0) : (model.try = model.try);
          model.eur === undefined ? (model.eur = 0) : (model.eur = model.eur);
          tenantTotalList.push(model);
          total += item.balance;
        }
      });

      var model = {};
      model.bankLogo = "TOPLAM";
      model.balance = parseFloat(total.toFixed(2));
      tenantTotalList.push(model);
      setBankListForTotal(tenantTotalList);
    });

    RequestHandler.get(
      `/TenantCurrency?$apply=groupby((Currency,CurrencyId))&$orderby=currencyId`
    ).then((response) => {
      setCurrencyList(response);
    });

    RequestHandler.get(
      `/TenantAccount?&$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setCount(response["@odata.count"]);
    });

    RequestHandler.get(`/Bank/GetFilterBank`).then((response) => {
      setBankSelect(response);
    });
  }, [setCurrencyList]);

  const titles = [];
  titles.push(t("bank"));
  currencyList.map((item) => {
    if (
      item.currency === "TRY" ||
      item.currency === "USD" ||
      item.currency === "EUR"
    ) {
      titles.push(item.currency);
    }
  });

  const columns = [
    {
      title: t("bank"),
      dataIndex: "bankLogo",
      align: "center",
      render: (text, row, index) => {
        return (
          <div style={{ width: 100 }}>
            <img src={row.bankLogo}></img>
          </div>
        );
      },
    },
    {
      title: t("total"),
      dataIndex: "balance",
      align: "right",

      render: (text, row, index) => {
        return row.totalBalance.toString().includes(".") ? (
          props.isDigitHomePage ? (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={row.totalBalance}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"₺"}
              />
            </div>
          ) : (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={parseFloat(row.totalBalance.toString().split(".")[0])}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"₺"}
              />
            </div>
          )
        ) : props.isDigitHomePage ? (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.totalBalance}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"₺"}
            />
            ,00
          </div>
        ) : (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.totalBalance}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"₺"}
            />
          </div>
        );
      },
    },
    {
      title: "TRY",
      dataIndex: "balance",
      align: "right",

      render: (text, row, index) => {
        return row.try.toString().includes(".") ? (
          props.isDigitHomePage ? (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={row.try}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"₺"}
              />
            </div>
          ) : (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={parseFloat(row.try.toString().split(".")[0])}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"₺"}
              />
            </div>
          )
        ) : props.isDigitHomePage ? (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.try}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"₺"}
            />
            ,00
          </div>
        ) : (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.try}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"₺"}
            />
          </div>
        );
      },
    },
    {
      title: "USD",
      dataIndex: "balance",
      align: "right",

      render: (text, row, index) => {
        return row.usd.toString().includes(".") ? (
          props.isDigitHomePage ? (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={row.usd}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"$"}
              />
            </div>
          ) : (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={parseFloat(row.usd.toString().split(".")[0])}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"$"}
              />
            </div>
          )
        ) : props.isDigitHomePage ? (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.usd}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"$"}
            />
            ,00
          </div>
        ) : (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.usd}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"$"}
            />
          </div>
        );
      },
    },
    {
      title: "EUR",
      dataIndex: "balance",
      align: "right",
      render: (text, row, index) => {
        return row.eur.toString().includes(".") ? (
          props.isDigitHomePage ? (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={row.eur}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"€"}
              />
            </div>
          ) : (
            <div style={{ fontSize: 13 }}>
              <CurrencyFormat
                value={parseFloat(row.eur.toString().split(".")[0])}
                displayType={"text"}
                decimalSeparator={","}
                thousandSeparator={"."}
                prefix={"€"}
              />
            </div>
          )
        ) : props.isDigitHomePage ? (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.eur}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"€"}
            />
            ,00{" "}
          </div>
        ) : (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.eur}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"€"}
            />{" "}
          </div>
        );
      },
    },
  ];

  const columnsForMobile = [
    {
      title: t("bank"),
      dataIndex: "bankName",
      align: "center",
      render: (text, row, index) => {
        return <strong>{text}</strong>;
      },
    },
    {
      title: t("total"),
      dataIndex: "balance",
      align: "center",

      render: (text, row, index) => {
        return (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.totalBalance}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"₺"}
            />
          </div>
        );
      },
    },
    {
      title: "TRY",
      dataIndex: "balance",
      align: "center",

      render: (text, row, index) => {
        return (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.try}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"₺"}
            />
          </div>
        );
      },
    },
    {
      title: "USD",
      dataIndex: "balance",
      align: "center",

      render: (text, row, index) => {
        return (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.usd}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"$"}
            />
          </div>
        );
      },
    },
    {
      title: "EUR",
      dataIndex: "balance",
      align: "center",
      render: (text, row, index) => {
        return (
          <div style={{ fontSize: 13 }}>
            <CurrencyFormat
              value={row.eur}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
              prefix={"€"}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div>
      {isDesktopOrLaptop ? (
        <Widget
          title={
            <h2 className="h4 gx-text-capitalize gx-mb-0">{t("bankList")}</h2>
          }
          extra={
            <p className="gx-text-primary gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">
              <a href="/bank-list">{t("allBanks")}</a>{" "}
              <i className="icon icon-long-arrow-right gx-fs-xxl gx-ml-2 gx-d-inline-flex gx-vertical-align-middle" />
            </p>
          }
        >
          {count < 5 ? (
            <div className="gx-table-responsive">
              <Table
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      history.push(
                        `bank-accounts?bankId=${
                          bankSelect.find((x) => x.value == record.bankName)
                            ?.text
                        }&skip=0&take=15&current=1&filter=bankId%20eq%20${
                          bankSelect.find((x) => x.value == record.bankName)
                            ?.text
                        }`
                      );
                    }, // click row
                  };
                }}
                className="gx-table-no-bordered"
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={t("noData")}
                    />
                  ),
                }}
                columns={columns}
                dataSource={bankListForTotal.filter(
                  (x) => x.bankLogo !== "TOPLAM"
                )}
                pagination={false}
                size="small"
                style={{ height: 490 }}
              />
            </div>
          ) : (
            <div className="gx-table-responsive">
              <Table
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      history.push(
                        `bank-accounts?bankId=${
                          bankSelect.find((x) => x.value == record.bankName)
                            ?.text
                        }&skip=0&take=15&current=1&filter=bankId%20eq%20${
                          bankSelect.find((x) => x.value == record.bankName)
                            ?.text
                        }`
                      );
                    }, // click row
                  };
                }}
                className="gx-table-no-bordered"
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={t("noData")}
                    />
                  ),
                }}
                columns={columns}
                dataSource={bankListForTotal.filter(
                  (x) => x.bankLogo !== "TOPLAM"
                )}
                pagination={false}
                size="small"
                style={{ height: 779 }}
              />
              {/* {
                    Screen.screen === 0 ?
                      <img style={{ marginTop: -380 }} src={require(`assets/images/Home/AllBanksFooter.png`)} />
                      : null
                  } */}
            </div>
          )}
        </Widget>
      ) : (
        <Widget
          title={
            <h2 className="h4 gx-text-capitalize gx-mb-0">{t("bankList")}</h2>
          }
          extra={
            <p className="gx-text-primary gx-mb-0 gx-pointer gx-d-none gx-d-sm-block"></p>
          }
        >
          <div className="gx-table-responsive">
            <Table
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    history.push(
                      `bank-accounts?bankId=${
                        bankSelect.find((x) => x.value == record.bankName)?.text
                      }&skip=0&take=15&current=1&filter=bankId%20eq%20${
                        bankSelect.find((x) => x.value == record.bankName)?.text
                      }`
                    );
                  }, // click row
                };
              }}
              className="gx-table-no-bordered"
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("noData")}
                  />
                ),
              }}
              columns={columnsForMobile}
              dataSource={bankListForTotal.filter(
                (x) => x.bankLogo !== "TOPLAM"
              )}
              pagination={false}
              size="small"
              style={{ height: 780 }}
            />
            <a href="/bank-list">{t("allBanks")}</a>{" "}
            <i className="icon icon-long-arrow-right gx-fs-xxl gx-ml-2 gx-d-inline-flex gx-vertical-align-middle" />
            {/* {
                Screen.screen === 0 ?
                  <img style={{ marginTop: -380 }} src={require(`assets/images/Home/AllBanksFooter.png`)} />
                  : null
              } */}
          </div>
        </Widget>
      )}
    </div>
  );
};

export default AllBankListTable;
